import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShareButtonComponent} from './share-button.component';


@NgModule({
  declarations: [
    ShareButtonComponent
  ],
  exports: [
    ShareButtonComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ShareButtonModule { }
